module.exports = __webpack_public_path__ + "catalog/items/firesafety/Sprinkler-System/Sprinkler-System.svg";